export default __webpack_public_path__ + "static/media/plone-logo.0a5672bc.svg";